import { twoDecimal } from "./helper";

// function get percentage of total answers
export const getProductAnswerPercentage = (answerTotal, totalApplicants) => {
    if (!answerTotal) return `0`
    let percent = twoDecimal(answerTotal / totalApplicants * 100);
    return percent === `00.00`
        ? `0`
        : percent === `100.00`
            ? `100`
            : percent
};

// function to get next or previous header obj
export const getProductNextAndPrevHeader = (headers, headerIdToCheck) => {
    const headersToCheck = headers.filter(header => (header.header_selection_type === 1 || header.header_selection_type === 2)),
        currentHeaderPosition = headersToCheck.findIndex(_ => _.id === headerIdToCheck),
        prevId = !!headersToCheck[currentHeaderPosition - 1]
            ? headersToCheck[currentHeaderPosition - 1].id
            : null,
        nextId = !!headersToCheck[currentHeaderPosition + 1]
            ? headersToCheck[currentHeaderPosition + 1].id
            : null;
    return {
        prev: prevId,
        next: nextId
    }
}

// function to get response text
export const getTextForResponseCount = (responseCount, responseText = 'RESPONSE') => `${responseCount} ${responseText}${responseCount === 1 ? '' : 'S'}`

// function get get average intensity
export const getAverageIntensity = (intensityList,
    answerTotal,
    intensityStartsFrom = 1) => {
    if (!intensityList.length || !answerTotal) return null;
    let totalIntensityCount = 0;
    intensityList.forEach((intensity, index) => {
        totalIntensityCount += ((index + intensityStartsFrom) * intensity.count);
    });
    const avgIntensityScale = twoDecimal(totalIntensityCount / answerTotal),
        avgIntensityCountText = intensityList[Math.round(avgIntensityScale) - intensityStartsFrom]
            && intensityList[Math.round(avgIntensityScale) - intensityStartsFrom].value
            ? intensityList[Math.round(avgIntensityScale) - intensityStartsFrom].value
            : '';
    return {
        avgIntensityCountText,
        avgIntensityScale
    }
}

// function to get benchmark intensity
export const getBenchmarkIntensity = (intensityList) => {
    if (!intensityList.length) return null;
    let onlyBenchmarkIntensity = intensityList.filter(_ => !!_.benchmark_intensity);
    if (!onlyBenchmarkIntensity.length) return null;
    return onlyBenchmarkIntensity[0]; // returning first matching
}

// function to get max value
export const getMaxValueFromArray = (arrayToCheck, keyToCheck) => Math.max(...arrayToCheck.map(_ => _[keyToCheck]));

// empty headers
export const emptyProductReportData = {
    overall: [{
        header_type: 'Product Experience',
        subTitle: 'Not enough reviews',
        ratingUnavailable: true,
        meta: {
            max_rating: 7,
        }
    }],
    headers: (headers = []) => {
        if (!headers
            || (headers && !headers.length)) {
            return [{
                header_type: 'Appearance',
                meta: {
                    max_rating: 7,
                },
                ratingUnavailable: true
            }, {
                header_type: 'Aroma',
                meta: {
                    max_rating: 7,
                },
                ratingUnavailable: true
            }, {
                header_type: 'Taste',
                meta: {
                    max_rating: 7,
                },
                ratingUnavailable: true
            }, {
                header_type: 'Aromatics to Flavour',
                meta: {
                    max_rating: 7,
                },
                ratingUnavailable: true
            }, {
                header_type: 'Texture',
                meta: {
                    max_rating: 7,
                },
                ratingUnavailable: true
            }]
        }
        return headers.filter(_ => _.header_selection_type === 1)
            .map(_ => {
                return {
                    header_type: _.header_type,
                    meta: {
                        max_rating: 7,
                    },
                    ratingUnavailable: true
                }
            })
    }
}

// get options for radar chart
export const getRadarChartOptions = (headerRating) => {
    if (!headerRating || (headerRating && !headerRating.length)) return null;
    return {
        angleLines: {
            display: false
        },
        legend: {
            display: false
        },
        scale: {
            ticks: {
                min: 0,
                max: 8,
                beginAtZero: true,
                maxTicksLimit: 8,
                stepSize: 1,
                autoSkip: false,
                display: false
            },
            gridLines: {
                display: false
            },
            pointLabels: {
                fontColor: headerRating.map((header) => header.meta.color_code),
                fontFamily: 'inherit',
                callback: function (label) {
                    return ' ' + label + ' '
                }
            }
        },
        scales: {
            gridLines: {
                display: false
            },
            ticks: {
                maxTicksLimit: 8,
                beginAtZero: true,
                display: false,
                callback: function () {
                    return '-';
                }
            },
        },
        maintainAspectRatio: false,
        responsive: true,
        plugins: {
            datalabels: {
                display: false,
            }
        }
    }
}

export const productErrorTexts = {
    'Invalid Address id': 'Please enter valid address.'
}

// getting initial intensity
export const getInitialIntensity = (optionObj = null,
    isFromQuestion = false,
    questionObj = null) => {
    if (isFromQuestion
        && questionObj
        && typeof questionObj.initial_intensity === "number") {
        return parseInt(questionObj.initial_intensity);
    }
    if (optionObj
        && typeof optionObj.initial_intensity === "number") {
        return parseInt(optionObj.initial_intensity);
    }
    return 1;
}

// method to check if max selection reached or not
export const checkIfMaxAromaOptionSelectedReached = (optionObj = null,
    questionObj = null,
    answerArr = []) => {
    if ((!questionObj
        || (questionObj
            && (!questionObj.max_aroma_selection
                || (questionObj.max_aroma_selection
                    && !questionObj.max_aroma_selection.length))))
        || (!optionObj
            && (optionObj
                && !optionObj.parent_sequence_id))
        || (!answerArr
            || (answerArr && !answerArr.length))) return {
                hasSelectedMaxAroma: false
            };
    // getting all sequence in an object
    let maxSequenceObj = {};
    questionObj.max_aroma_selection.forEach(seq => {
        maxSequenceObj[seq.sequence_id] = seq.max_selection;
    });
    // getting all answer count in an object
    let answerSequenceCheck = {};
    answerArr.forEach(answer => {
        const parentSequenceId = answer.parent_sequence_id;
        if (parentSequenceId) {
            answerSequenceCheck[parentSequenceId] = answerSequenceCheck[parentSequenceId]
                ? answerSequenceCheck[parentSequenceId] + 1
                : 1
        }
    })
    // returning true or false depending on the nnumber of answer
    if (!maxSequenceObj[optionObj.parent_sequence_id] || !answerSequenceCheck[optionObj.parent_sequence_id]) {
        return {
            hasSelectedMaxAroma: false
        }
    }
    return {
        hasSelectedMaxAroma: maxSequenceObj[optionObj.parent_sequence_id] <= answerSequenceCheck[optionObj.parent_sequence_id],
        aromaObj: questionObj.option
            && !!questionObj.option.length
            && questionObj.option.filter(_ => _.sequence_id === optionObj.parent_sequence_id).length
            ? {
                ...questionObj.option.filter(_ => _.sequence_id === optionObj.parent_sequence_id)[0],
                maxSelection: maxSequenceObj[optionObj.parent_sequence_id]
                    ? maxSequenceObj[optionObj.parent_sequence_id]
                    : 0
            }
            : {
                maxSelection: 0
            }
    };
}


export const PRODUCT_REVIEW_STATES = {
    NOTSTARTED: null,
    INPROGRESS: 1, //show in progress text
    COMPLETED: 2,
};